import { render, staticRenderFns } from "./smartlink.vue?vue&type=template&id=6873c3b4"
import script from "./smartlink.vue?vue&type=script&lang=js"
export * from "./smartlink.vue?vue&type=script&lang=js"
import style0 from "./smartlink.vue?vue&type=style&index=0&id=6873c3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports